import angular from 'angular';
import { MeurhAdmissoesValetransporteFormController } from './valetransporte.form.controller';

export class MeurhAdmissoesValetransporteFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesValetransporteFormComponent';
	static controller = MeurhAdmissoesValetransporteFormController;
	static template = require('!!html-loader!./valetransporte.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
